//export const WEBSERVICE_IP = 'https://microservices.contreras.website/gday/';
export const WEBSERVICE_IP = 'http://localhost:3001';

